module.exports = __webpack_public_path__ + "img/youmu konpaku_lw.9722a1ec.png";